import { render } from "./HomeStock.vue?vue&type=template&id=cbd74194&scoped=true"
import script from "./HomeStock.vue?vue&type=script&lang=js"
export * from "./HomeStock.vue?vue&type=script&lang=js"

import "./HomeStock.vue?vue&type=style&index=0&id=cbd74194&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbd74194"]])

export default __exports__